import {
    useCallback, useEffect, useState, MutableRefObject,
} from 'react'
import isEqual from 'lodash/isEqual'

export default function useRefHeight(ref: MutableRefObject<HTMLDivElement>, staticValue?: number) {
    const [
        height,
        setHeight,
    ] = useState<'auto' | number>(staticValue || 'auto')

    useEffect(() => {
        if (!ref.current || staticValue) return

        const elHeight = ref.current?.scrollHeight || 'auto'

        if (!isEqual(height, elHeight)) {
            setHeight(elHeight)
        }
    }, [
        height,
        ref,
        staticValue,
    ])

    return useCallback(() => {
        return height
    }, [height])
}
